// DO NOT EDIT THIS FILE. THIS FILE IS CREATED BY `create-icon-component.js` SCRIPT
import { createSvgIcon } from "../createSvgIcon";
import svg from "../svg/icw-information-ol.svg";
export var InformationOl = createSvgIcon({
  svg: svg,
  displayName: "InformationOl"
});
//# sourceMappingURL=InformationOl.js.map